module.exports = __webpack_public_path__ + "img/finances-block-icon-one.f4356f35.svg";